import {Directive, Injector,} from '@angular/core';
import {MatSelect} from '@angular/material/select';
import {AbstractControl} from "@angular/forms";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {nårGuiErOppdatert} from "felles-ng2/infrastruktur/angular/nårGuiErOppdatert";

/** legger til et 'velg alle' element først i dropdown panelet som ved klikk endrer mellom alle/ingen valgt */
@Directive({
    selector: 'mat-select[velgAlle]',
})
export class MatSelectVelgAlleDirektiv {

    constructor(private matSelect: MatSelect, private oversettelser: Oversettelser, injector: Injector) {
        this.matSelect = matSelect;
        this.matSelect.openedChange
          .pipe(takeUntilDestroyed())
          .subscribe(åpen => {
              if (!åpen) return;
              nårGuiErOppdatert(() => this.initPanel(), injector);
          })
    }

    //private hjelpemetoder

    private initPanel() {
        const panel: HTMLDivElement = this.matSelect.panel.nativeElement;
        const velgAlleElement = document.createElement('a');
        velgAlleElement.classList.add('matSelect--velgAlle');
        velgAlleElement.innerText = this.oversettelser.oversett(i18n('velg alle ({antall})'), {antall: this.alleOpsjoner().length});
        velgAlleElement.addEventListener('click', () => this.velgAlle());
        //legg 'velg alle' til først i panelet
        panel.prepend(velgAlleElement);
    }

    private velgAlle() {
        const alleVerdier = this.alleOpsjoner();
        if (this.formControl().value.length !== alleVerdier.length)
            this.formControl().setValue(alleVerdier);
        else
            this.formControl().setValue([]);
    }

    private formControl(): AbstractControl<any[]> {
        return this.matSelect.ngControl.control!;
    }

    private alleOpsjoner() {
        return this.matSelect.options.map(opt => opt.value);
    }
}
